import { render, staticRenderFns } from "./CableTv.vue?vue&type=template&id=584e4fdf&scoped=true"
import script from "./CableTv.vue?vue&type=script&lang=js"
export * from "./CableTv.vue?vue&type=script&lang=js"
import style0 from "./CableTv.vue?vue&type=style&index=0&id=584e4fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e4fdf",
  null
  
)

export default component.exports